import { render, staticRenderFns } from "./JsonLD.vue?vue&type=template&id=3a8ed66e&"
import script from "./JsonLD.vue?vue&type=script&lang=js&"
export * from "./JsonLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports